import axios from "axios";

const BASE_URL = "https://food.totalfresh.co/public/api/v2/admin";

export const getAuthToken    = () => localStorage.getItem("auth_token");
export const getProfile    = () => JSON.parse(localStorage.getItem("profile"));
export const getRememberToken = () => localStorage.getItem("remember_token");

export const setAuthToken    = (token) => localStorage.setItem("auth_token", token);
export const setRememberToken = (token) => localStorage.setItem("remember_token", token);
export const setProfile = (data) => localStorage.setItem("profile", JSON.stringify(data));

export const clearAuthToken  = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("profile");
}
export const clearAllTokens  = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("remember_token");
};


const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: { "Content-Type": "application/json", Accept: "application/json" },
});

// Attach Bearer token to every request automatically
apiClient.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

export default apiClient;